import React, { useEffect, useState } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as bomAction from '../Bom/store/BOMConfig.action';
import * as SubmitAction from './Store/Submit.action';
import SubmitLogsCard from './SubmitDownloadLogs/SubmitLogsCard';
import Loader from '../../../Components/Utility/Loader/Loader';

function SubmitDownloadLog() {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const reducer = useSelector((estate) => estate);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const logId = queryParams.get('logId') ? queryParams.get('logId') : '';
  const forMail = queryParams.get('forMail');

  const { devOrderId } = useParams();
  const {
    BOMConfigDetails: { productDetails },
    SubmitDownloadReducer,
    UserDetails,
    Users,
  } = reducer;
  const { SubmitLogData } = SubmitDownloadReducer;
  let email = '';
  if (forMail === 'true') {
    email = queryParams.get('email');
    email = decodeURIComponent(email);
  } else {
    email = UserDetails?.userInfo?.email;
  }
  const role = UserDetails?.userInfo?.role;

  const { logInRights } = Users;

  const [detailInfo, setDetailInfo] = useState(null);
  const [state, setState] = useState({
    submitLogdata: [],
    loading: true,
    backButtonShow: true,
  });
  const { submitLogdata, loading, backButtonShow } = state;

  useEffect(() => {
    let back_ButtonShow = true;
    if (role !== 'Admin') {
      logInRights?.forEach((log) => {
        back_ButtonShow = log?.submitTechPack || log?.downloadTechPack;
      });
    }
    setState((prev) => ({
      ...prev,
      backButtonShow: back_ButtonShow,
    }));
  }, [logInRights, role]);

  const emptyString = (obj) => {
    return obj || '';
  };

  useEffect(() => {
    setDetailInfo(productDetails);
  }, [productDetails]);

  useEffect(() => {
    const init = async () => {
      if (forMail === 'true') {
        const params = {
          email,
          devOrderId,
        };
        await SubmitAction.requestForDownload(params);
        const SubmitLog = await SubmitAction.retriveSubmitLog(params);
        setState((prev) => ({
          ...prev,
          submitLogdata: SubmitLog,
        }));
      } else {
        await dispatch(bomAction.fetchProductDetails(devOrderId));
        const obj = {
          devOrderId,
        };
        await dispatch(SubmitAction.getSubmitDOwnloadLogs(obj));
      }

      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    };
    init();
  }, [devOrderId, dispatch]);
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      submitLogdata: SubmitLogData,
    }));
  }, [SubmitLogData]);

  const activeInactiveSubmitLog = async (item, index) => {
    const obj = {
      logId: item?._id,
      isActive: !item?.isActive,
    };
    const itemObj = {
      ...item,
      isActive: obj.isActive,
    };
    await dispatch(SubmitAction.activeInactiveSubmitLogs(obj, t));
    const cloneData = submitLogdata;
    cloneData[index] = itemObj;
    setState((prev) => ({
      ...prev,
      submitLogdata: cloneData,
    }));
  };

  const downloadFile = async (item) => {
    const data = {
      ...item,
      timeZone,
    };
    const s3params = {
      ...item,
      devOrderId,
      email: encodeURIComponent(email),
      timeZone,
    };
    await dispatch(SubmitAction.downloadS3LogFiles(s3params, t));
    await dispatch(SubmitAction.downloadByUpdate({ ...data, logId: item._id, fromSubmit: true }, t));
  };
  const deleteFiles = async (id) => {
    await dispatch(SubmitAction.deleteSubmitLogs(id, t));
    const obj = {
      devOrderId,
    };
    await dispatch(SubmitAction.getSubmitDOwnloadLogs(obj));
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <span className="title">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLOAD_LOG.SUBMIT_LOG')}</span>
          {detailInfo?.number && <span className="title w-xs-200px">&nbsp;&nbsp;|&nbsp; &nbsp;</span>}
          <span className="title">{emptyString(detailInfo?.number)}</span>
        </div>
        {backButtonShow && !logId && (
          <Link
            className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib ml-auto"
            to={`/development-order/${devOrderId}/submit-download`}
          >
            {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLOAD_LOG.BACK')}
          </Link>
        )}
      </div>
      <div className="d-flex justify-content-end m-3">
        {!logId && role !== 'Supplier' && (
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-page-filter" to={`/development-order/${devOrderId}/submit-download-logs`}>
            {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLOAD_LOG.SUBMIT')}
          </Link>
        )}
        {!logId && role !== 'Supplier' && (
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-page-filter" to={`/development-order/${devOrderId}/download-logs`}>
            {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLOAD_LOG.DOWNLOAD')}
          </Link>
        )}
      </div>

      <div>
        {loading ? (
          <Loader />
        ) : (
          <Container fluid>
            <Row>
              {role === 'Supplier'
                ? // If the user's role is 'Supplier', filter and map only isActive:true data
                  submitLogdata
                    .filter((item) => item?.isActive)
                    .map((item, i) => (
                      <SubmitLogsCard
                        item={item}
                        key={item?._id}
                        index={i}
                        activeInactiveSubmitLog={activeInactiveSubmitLog}
                        downloadFile={downloadFile}
                        deleteFiles={deleteFiles}
                        highLightId={logId}
                      />
                    ))
                : // If the user's role is not 'Supplier', display all data
                  submitLogdata.map((item, i) => (
                    <SubmitLogsCard
                      item={item}
                      key={item?._id}
                      index={i}
                      activeInactiveSubmitLog={activeInactiveSubmitLog}
                      downloadFile={downloadFile}
                      deleteFiles={deleteFiles}
                      highLightId={logId}
                    />
                  ))}
            </Row>
            {role !== 'Supplier' && submitLogdata?.length === 0 && (
              <div>
                <p className="mt-3 text-center"> {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.SUBMIT_DOWNLOAD_LOG.NO_LOG_AVAILBLE')}</p>
              </div>
            )}
            {role === 'Supplier' && !submitLogdata?.some((item) => item?.isActive) && <div className="text-center mt-3">No logs available.</div>}
          </Container>
        )}
      </div>
    </>
  );
}

export default SubmitDownloadLog;
